export namespace Messages {
    export namespace Dialog {
        export const OldPackage = "このお薬は、調剤月から12カ月以上経っております。薬剤師または医療機関に、ご相談下さい。";
        export const NotFoundPackage = "お薬の読取が、できませんでした。「1Dサービス」に対応する前に一包化された分包品の可能性があります。くわしくは、よくある質問画面を参照ください。";
        export const InvalidSerialCode = "お薬の読取が、できませんでした。別の包のバーコードを読んでも読取れない場合には、よくある質問画面を参照ください。";
        export const AccessError = "通信環境の良いところで、再度バーコードの読取りをお願いします。改善されない場合はよくある質問画面を参照ください。";
        export const CameraPermissionError = "ブラウザにカメラの利用許可が設定されていますか？確認手順はよくある質問画面を参照ください。";
    }
}
